import styled from 'styled-components';

export const SelectWrapper = styled('div')`
  ${({ theme, withoutBorder, withBorder }) => `
      border: none;
      display: inline-block;
      position: relative;
      overflow: hidden;
      min-width: 180px;
    ${
      (withoutBorder && 'border: none;') ||
      (withBorder && `border: 1px solid ${theme.colors.grey2}; width: ${theme.spacing.full};`) ||
      `border-bottom: 1px solid ${theme.colors.grey2}; width: ${theme.spacing.full}; `
    }
`}
`;

export const SelectStyled = styled('select')`
  ${({ theme, disabled, size }) => `
    width: ${theme.spacing.full};
    
    background: none;
    outline: none;
    border: none;
    appearance: none;
    -webkit-appearance: none;
    position: relative;
    z-index: 1;
    height: auto;
    font-size: ${theme.fontSize.px16};
    padding: 10px 40px 10px 12px;
    ${
      size === 'px14'
        ? `
        font-size: ${theme.fontSize.px14};
        padding: 5px 30px 5px 10px;
        `
        : ``
    }
    + svg {
        width: ${theme.spacing.px25};
        height: ${theme.spacing.px25};    
        right: ${theme.spacing.px10};
        top: ${theme.spacing.px5};
        fill: ${theme.colors.grey2};
        position: absolute;
        z-index: 0;
        ${
          size === 'px14'
            ? `
            width: ${theme.spacing.px15};
            height: ${theme.spacing.px15};
            top: ${theme.spacing.px5};
            `
            : ``
        }
    }
    ${disabled ? 'cursor: not-allowed;' : 'cursor: pointer;'}
`}
`;
